import { useNuxtApi } from '@shared/nuxt/useNuxtApi'

type LayoutAnalyticsResponse = {
  google?: {
    verification?: string
  }
  yandex?: {
    verification?: string
  }
}

/**
 * Загружает verification-токены аналитических систем для layout.
 *
 * @returns verification-токены Yandex и Google
 */
export const useLayoutAnalytics = async () => {
  const { data } = await useNuxtApi<LayoutAnalyticsResponse>('/api/analytics')

  return {
    yandexVerification: data.value?.yandex?.verification,
    googleVerification: data.value?.google?.verification,
  }
}
